import {
  Text,
  GreyGrey80,
  Primary14SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'

import { useQuoteByline } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/QuoteByline/useQuoteByline'

export const QuoteByline = () => {
  const { createdBy, createdAt } = useQuoteByline()

  if (!createdBy && !createdAt) {
    return null
  }

  return (
    <Text
      {...Primary13Regular}
      marginBottom="16px"
      paddingX="18px"
      color={GreyGrey80}
    >
      Created
      {createdBy && (
        <>
          {' '}
          by{' '}
          <Text as="span" {...Primary14SemiBold} color="inherit">
            {createdBy}
          </Text>
        </>
      )}
      {createdAt && ` on ${createdAt}`}
    </Text>
  )
}
